import { render, staticRenderFns } from "./products.vue?vue&type=template&id=f096e9e8&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=f096e9e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../globalsearch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f096e9e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/globalsearch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f096e9e8')) {
      api.createRecord('f096e9e8', component.options)
    } else {
      api.reload('f096e9e8', component.options)
    }
    module.hot.accept("./products.vue?vue&type=template&id=f096e9e8&scoped=true", function () {
      api.rerender('f096e9e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "youtubewidget/src/components/products.vue"
export default component.exports